"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addError = exports.startView = exports.configure = void 0;
const filter_1 = require("./filter");
const constants_1 = require("./constants");
const browser_rum_1 = require("@datadog/browser-rum");
const originWhitelist_1 = require("./originWhitelist");
const configure = ({ appId, appName, appVersion, clientPublicToken, environment, trackViewsManually = false, }) => {
    browser_rum_1.datadogRum.init({
        allowedTracingUrls: originWhitelist_1.originWhitelist,
        applicationId: appId,
        beforeSend: filter_1.filterRumBeforeSend,
        clientToken: clientPublicToken,
        defaultPrivacyLevel: "mask",
        env: environment,
        service: appName,
        sessionReplaySampleRate: 0,
        sessionSampleRate: 100,
        silentMultipleInit: true,
        site: constants_1.DATADOG_SITE,
        telemetrySampleRate: 20,
        traceSampleRate: 100,
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: false,
        trackViewsManually: trackViewsManually,
        version: appVersion,
    });
    if (false) {
        browser_rum_1.datadogRum.startSessionReplayRecording();
    }
};
exports.configure = configure;
const startView = ({ name: viewName }) => {
    browser_rum_1.datadogRum.startView(viewName);
};
exports.startView = startView;
const addError = (error, context) => {
    const filteredError = (0, filter_1.filterUnknown)(error);
    const filteredContext = (0, filter_1.filterContext)(context);
    browser_rum_1.datadogRum.addError(filteredError, filteredContext);
};
exports.addError = addError;
//# sourceMappingURL=realUserMonitoring.js.map